import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface PromoPopupProps {
  onRequestQuote: () => void;
}
export function PromoPopup({
  onRequestQuote
}: PromoPopupProps) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const {
    t,
    lang
  } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(timer);
  }, []);
  if (!visible || dismissed) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-276">
      <div className="absolute inset-0 bg-black bg-opacity-70 backdrop-blur-sm" onClick={() => setDismissed(true)} data-id="element-277" />
      <div className="relative z-10 bg-dark-surface border border-dark-border rounded-industrial max-w-lg w-full shadow-2xl overflow-hidden" data-id="element-278">
        <div className="h-1 w-full bg-brand-yellow" data-id="element-279" />
        <div className="p-7 md:p-9" data-id="element-280">
          <button onClick={() => setDismissed(true)} className="absolute top-5 right-5 text-gray-500 hover:text-white transition-colors" aria-label="Zatvori" data-id="element-281">
            <XIcon className="w-5 h-5" data-id="element-282" />
          </button>

          <div className="inline-block bg-brand-yellow text-dark-bg text-xs font-black uppercase tracking-widest px-3 py-1 rounded mb-5" data-id="element-283">
            {t.popup.badge}
          </div>

          <h3 className="text-2xl md:text-3xl font-black text-white leading-tight mb-4" data-id="element-284">
            {t.popup.title}
          </h3>

          <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-2" data-id="element-285">
            {t.popup.body}{' '}
            <span className="text-white font-semibold" data-id="element-286">{t.popup.date}</span>{' '}
            {t.popup.bonus}.
          </p>
          <p className="text-gray-400 text-sm mb-1" data-id="element-287">{t.popup.avans}</p>

          <p className="text-gray-500 text-xs mb-6 border-t border-dark-border pt-4 mt-4" data-id="element-288">
            {t.popup.limited}
          </p>

          <div className="flex flex-col gap-3" data-id="element-289">
            <Button variant="primary" size="lg" className="w-full" onClick={() => {
            setDismissed(true);
            onRequestQuote();
          }} data-id="element-290">
              {t.popup.btnPrimary}
            </Button>
            <button onClick={() => setDismissed(true)} className="text-sm text-gray-500 hover:text-gray-300 transition-colors text-center py-2" data-id="element-291">
              {lang === 'en' ? 'Maybe later' : lang === 'ru' ? 'Может быть позже' : 'Možda kasnije'}
            </button>
          </div>
        </div>
      </div>
    </div>;
}